var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeLine = function SvgHomeLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 19.2a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9V9.74a.9.9 0 0 1 .347-.71l7.2-5.6a.9.9 0 0 1 1.106 0l7.2 5.6a.9.9 0 0 1 .347.71zm-1.8-.9v-8.12l-6.3-4.9-6.3 4.9v8.12z"
  })));
};
export default SvgHomeLine;